import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerComponent, NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DataGridComponent } from "../../../Common/Components/data-grid/data-grid.component";
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { ApiService } from '../../../Services/api.service';
import { AuthService } from '../../../Services/auth.service';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'app-associate-lot',
  standalone: true,
  imports: [CommonModule, NzInputModule, ReactiveFormsModule, NzIconModule, NzAutocompleteModule, NzEmptyModule,
    NzDatePickerModule, NzButtonModule, DataGridComponent, NzSelectModule, FormsModule, ConfirmPopupComponent],
  templateUrl: './associate-lot.component.html',
  styleUrl: './associate-lot.component.scss'
})
export class AssociateLotComponent {
  constructor(private apiService: ApiService, private authService: AuthService) { }
  @Input() categoryData: any = "";
  @Input() catalogId: any = "";
  lotList: any = {};
  otherLotList: any = [];
  lotValues: any = [];
  otherLotValues: any = [];
  edpArNoList: any = [];
  searchKey: any = "";
  newEDPAssociations: any = [];
  selectedIds = new Set<number>();
  validateValues: boolean = false;
  showModal: boolean = false;
  table_fields = [{
    field: 'lotId',
    header: '',
    type: "checkbox"
  },
  {
    field: 'lotId',
    header: 'Lot Id',
    compare: (a: any, b: any) => (a.lotId ?? "").localeCompare((b.lotId ?? ""))
  },
  {
    field: 'lotDesc',
    header: 'Lot Description',
    compare: (a: any, b: any) => (a.lotDesc ?? "").localeCompare((b.lotDesc ?? "")),
    editable: true
  },
  {
    field: '',
    header: 'Action',
    icons: ['edit', 'delete'],
    type: 'icon',
    showIcons: true
  }];
  otherLotSearch$ = new Subject<string>();
  @Output() emitLotChange = new EventEmitter<any>();
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  searchText: string = '';
  otherLotSearched: boolean = false;


  ngOnInit(): void {
    this.otherLotSearch$.pipe(debounceTime(500),
      distinctUntilChanged(),
      switchMap(value =>
        this.apiService.getOtherStyleLots(this.categoryData.categorySeqNo, value)
      ))
      .subscribe(res => {
        if (res) {
          this.otherLotList = res;
          this.otherLotList.map((node: any) => {
            Object.assign(node, { disabled: false })
          });
          if (this.otherLotValues && this.otherLotValues.length > 0) {
            const userSet = new Set(this.otherLotValues.map((node: any) => node.lotId));
            this.otherLotList.forEach((node: any) => {
              if (userSet.has(node.lotId)) {
                node.disabled = true;
              }
            })
          }
        }
      });

  }

  ngOnChanges(): void {
    if (this.categoryData && this.categoryData.styleId) {
      this.getLotList();
    }
  }

  deleteRow(data: any) {
    let post = [{ "catalogId": this.catalogId, "lotId": data.lotId, "categorySeqNo": this.categoryData.categorySeqNo, "hideOnWeb": data.hideOnWeb ? 1 : 0 }];
    this.deleteLot(post);
  }

  updateRow(data: any) {
    let post = [{ "catalogId": this.catalogId, "lotId": data.lotId, "lotDesc": data.lotDesc, "categorySeqNo": this.categoryData.categorySeqNo, "hideOnWeb": data.hideOnWeb ? 1 : 0, "updateType": "UPDATE" }];
    this.saveLotApi(post);

  }

  deAssociate() {
    this.showModal = true;
  }

  onDeleteConfirm(): void {
    this.showModal = false;
    const deleteList = [...this.selectedIds];
    let post: any = [];
    deleteList.map(node => {
      post.push({ "lotId": node, "categorySeqNo": this.categoryData.categorySeqNo, "catalogId": this.catalogId })
    });
    this.deleteLot(post);
  }

  onDeleteCancel(): void {
    this.showModal = false;
  }

  selectedRows(selectedIds: any) {
    this.selectedIds = selectedIds;
  }

  getLotList(update?: boolean) {
    this.apiService.getLots(this.categoryData.categorySeqNo, this.categoryData.styleId).subscribe(response => {
      if (response) {
        this.lotList = response;
        // this.lotList.map((node: any) => {
        //   Object.assign(node, { disabled: false })
        // });
        if (update) {
          if (this.lotList.associatedLots && this.lotList.associatedLots.length > 0) {
            this.emitLotChange.emit(
              this.lotList.associatedLots.map((res: any) => ({
                lotId: res.lotId,
                hideOnWeb: res.hideOnWeb
              }))
            );
          }
          else {
            this.emitLotChange.emit([]);
          }

        }
      }
    })

  }

  getOtherLotList(evt: any) {
    if (evt) {
      this.otherLotSearch$.next(evt);
      this.otherLotSearched = true;
    }
  }

  resetForm() {
    this.lotValues = [];
    this.otherLotValues = [];
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
  }

  closeOtherSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
    this.otherLotList = []
  }

  resetSearch(isOpen: any) {
    if (isOpen) {
      this.otherLotList = [];
      this.otherLotSearched = false;
    }
  }

  saveLot() {
    if (this.otherLotValues.length == 0 && this.lotValues.length == 0) {
      this.validateValues = true;
      return
    }
    this.validateValues = false;
    let post: any = [];
    if (this.lotValues.length > 0) {
      this.lotValues.map((node: any) => {
        post.push({
          "catalogId": this.catalogId,
          "categorySeqNo": this.categoryData.categorySeqNo,
          "lotId": node.lotId,
          "lotDesc": node.lotDesc,
          "hideOnWeb": 0,
          "updateType": "ADD"
        })
      });
    }
    if (this.otherLotValues.length > 0) {
      this.otherLotValues.map((node: any) => {
        post.push({
          "catalogId": this.catalogId,
          "categorySeqNo": this.categoryData.categorySeqNo,
          "lotId": node.lotId,
          "lotDesc": node.lotDesc,
          "updateType": "ADD"
        })
      });
    }
    this.saveLotApi(post);
  }

  saveLotApi(data: any) {
    this.apiService.addAssociateLots(this.categoryData.styleId, data).subscribe(res => {
      this.apiService.createNotification('success', res.message);
      this.resetForm();
      this.getLotList(true);
    }, err => {
      this.apiService.createNotification('error', err?.error.message);
    })
  }

  deleteLot(data: any) {
    this.apiService.deleteAssociateLots(data).subscribe(res => {
      this.apiService.createNotification('success', res.message);
      this.resetForm();
      this.getLotList(true);
    }, err => {
      this.apiService.createNotification('error', err?.error.message);
    })
  }

  searchLot(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, 'lotId');
  }

}
